import { render } from "./index.vue?vue&type=template&id=6d45d7c2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6d45d7c2&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=6d45d7c2&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d45d7c2"],['__file',"src/extra/VueCropper/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d45d7c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d45d7c2', __exports__)) {
    console.log('reload')
    api.reload('6d45d7c2', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=6d45d7c2&scoped=true", () => {
    console.log('re-render')
    api.rerender('6d45d7c2', render)
  })

}


export default __exports__